import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import {
    LIDAR_TESTER_EVENT_CLEAR_TIMER_MS
} from "../../../util/Constants";

const colorMap = {
    1: "#e6e6e6", // grey
    2: "green",
    3: "red"
}

const LIDAR_SENSOR_STYLE = (state) => {
    return {
        background: colorMap[state],
        width: "21px",
        height: "21px",
        borderRadius: 50,
        border: '1px solid black',
        textAlign: 'center',
        lineHeight: '19px',
        color: 'white'
    }
}

const LidarSensor = (props) => {

    const {sensorState} = props;
    const [state, setState] = useState(1);
    const [value, setValue] = useState("");

    useEffect(() => {
        setSensorStateAndValue(sensorState.state, sensorState.value)
        let timeout = setTimeout(() => {
            setSensorStateAndValue(1, "")
        }, LIDAR_TESTER_EVENT_CLEAR_TIMER_MS)

        return () => {
            clearTimeout(timeout)
        }
    }, [sensorState.time])

    const setSensorStateAndValue = (state, value) => {
        setState(state)
        setValue(value)
    }

    return (
        <div style={LIDAR_SENSOR_STYLE(state)}>{value}</div>
    )
}

export default injectIntl(LidarSensor);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/LidarSensor.js